import React from 'react';
import { getAttendanceImage, getRankImage } from '../../../models/gamification';


const GamificationBadges = ({ gamifiedActivities, member, achievementsSettings = [], rankSettings = [], awardedAchievementIds = [], awardedAchievements = [] }) => {
    const memberXp = member?.xpTotal || member?.XP || 0;

    const earnedActivities = gamifiedActivities?.filter(act => member?.passedActivityIds?.includes(act.id)) || [];
    const earnedRanks = rankSettings?.filter(rank => memberXp >= rank.minXp) || [];
    
    // Conquistas baseadas nas configurações globais (ex: frequência)
    const settingsAchievements = achievementsSettings?.filter(ach => awardedAchievementIds.includes(ach.id)) || [];
    
    // Conquistas extras vindas de eventos (que têm type === 'extra') e não estão nas globais
    const extraAchievements = awardedAchievements?.filter(ach => ach.type === 'extra') || [];
    
    // Evitar duplicatas internas em cada lista
    const finalSettingsAchievements = Array.from(new Map(settingsAchievements.map(ach => [ach.idAchievement || ach.id, ach])).values());
    const finalExtraAchievements = Array.from(new Map(extraAchievements.map(ach => [ach.idAchievement || ach.id, ach])).values());

    // Função helper para renderizar a mesma estrutura de ícone de conquista
    const renderBadgeItems = (achievementsList) => {
        return achievementsList.map((ach) => (
            <div key={ach.id} className="d-flex flex-column align-items-center position-relative" style={itemWrapperStyle}>
                <div 
                    className={`rounded-circle d-flex align-items-center justify-content-center`}
                    style={{ width: "100%", aspectRatio: "1 / 1", backgroundColor: 'transparent', overflow: 'hidden', transition: 'all 0.3s ease' }}
                >
                    {ach.imageId ? (
                        <img src={getAttendanceImage(ach.imageId) || ach.imageId} alt={ach.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    ) : (
                        <i className={`mdi ${ach.icon || 'mdi-medal'}`} style={{ color: '#f1b44c', fontSize: "clamp(1rem, 2vw, 2rem)" }}></i>
                    )}
                </div>
                <span className="mt-2 text-center text-dark fw-bold w-100" style={{ fontSize: "clamp(0.8rem, 2vw, 1.2rem)", lineHeight: "1.2", wordBreak: 'break-word' }}>
                    {ach.name}
                </span>
            </div>
        ));
    };

    const itemWrapperStyle = { 
        width: "calc((100% - 1.5rem) / 4)", 
        maxWidth: "120px", 
        minWidth: "70px" 
    };

    return (
        <div className="w-100 mt-2 pb-4">
            
            {earnedActivities.length > 0 && (
                <>
                    <h5 className="text-dark fw-bold mb-0" style={{ borderLeft: "5px solid #f1b44c", paddingLeft: "12px", fontSize: "1.4rem" }}>Minhas Insígnias</h5>
                    <div 
                        className="d-flex justify-content-start align-items-start py-3 w-100 flex-wrap gap-2"
                    >
                        {earnedActivities.map((act) => {
                            const isCurrent = member?.activityIds?.includes(act.id);
                            
                            return (
                                <div key={act.id} className="d-flex flex-column align-items-center position-relative" style={itemWrapperStyle}>
                                    <div 
                                        className={`rounded-circle d-flex align-items-center justify-content-center ${isCurrent ? 'border border-primary shadow-lg border-2' : ''}`}
                                        style={{ 
                                            width: "100%",
                                            aspectRatio: "1 / 1",
                                            backgroundColor: "transparent",
                                            overflow: 'hidden',
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        {act.photoUrl ? (
                                            <img 
                                                src={act.photoUrl} 
                                                alt={act.name} 
                                                style={{ width: "100%", height: "100%", objectFit: "cover" }} 
                                            />
                                        ) : (
                                            <i className="mdi mdi-shield-star" style={{ color: '#f1b44c', fontSize: "clamp(1rem, 2vw, 2rem)" }}></i>
                                        )}
                                    </div>
                                    <span className="mt-2 text-center text-dark fw-bold w-100" style={{ fontSize: "clamp(0.8rem, 2vw, 1.2rem)", lineHeight: "1.2", wordBreak: 'break-word' }}>
                                        {act.name}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </>
            )}

            {earnedRanks.length > 0 && (
                <>
                    <h5 className="text-dark fw-bold mb-0 mt-4" style={{ borderLeft: "5px solid #f1b44c", paddingLeft: "12px", fontSize: "1.4rem" }}>Conquistas por XP</h5>
                    <div 
                        className="d-flex justify-content-start align-items-start py-3 w-100 flex-wrap gap-2"
                    >
                        {earnedRanks.map((rank) => {
                            return (
                                <div key={rank.id} className="d-flex flex-column align-items-center position-relative" style={itemWrapperStyle}>
                                    <div 
                                        className={`rounded-circle d-flex align-items-center justify-content-center`}
                                        style={{ 
                                            width: "100%",
                                            aspectRatio: "1 / 1",
                                            backgroundColor: 'transparent',
                                            overflow: 'hidden',
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        {getRankImage(rank.imageId || rank.id) ? (
                                            <img 
                                                src={getRankImage(rank.imageId || rank.id)} 
                                                alt={rank.name} 
                                                style={{ width: "100%", height: "100%", objectFit: "cover" }} 
                                            />
                                        ) : (
                                            <i className="mdi mdi-shield-star" style={{ color: '#f1b44c', fontSize: "clamp(1rem, 2vw, 2rem)" }}></i>
                                        )}
                                    </div>
                                    <span className="mt-2 text-center text-dark fw-bold w-100" style={{ fontSize: "clamp(0.8rem, 2vw, 1.2rem)", lineHeight: "1.2", wordBreak: 'break-word' }}>
                                        {rank.name}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </>
            )}

            {finalSettingsAchievements.length > 0 && (
                <>
                    <h5 className="text-dark fw-bold mb-0 mt-4" style={{ borderLeft: "5px solid #f1b44c", paddingLeft: "12px", fontSize: "1.4rem" }}>Conquistas por Presença</h5>
                    <div className="d-flex justify-content-start align-items-start py-3 w-100 flex-wrap gap-2">
                        {renderBadgeItems(finalSettingsAchievements)}
                    </div>
                </>
            )}

            {finalExtraAchievements.length > 0 && (
                <>
                    <h5 className="text-dark fw-bold mb-0 mt-4" style={{ borderLeft: "5px solid #f1b44c", paddingLeft: "12px", fontSize: "1.4rem" }}>Eventos Extras</h5>
                    <div className="d-flex justify-content-start align-items-start py-3 w-100 flex-wrap gap-2">
                        {renderBadgeItems(finalExtraAchievements)}
                    </div>
                </>
            )}

        </div>
    );
};

export default GamificationBadges;
